"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Gate = _interopRequireDefault(require("../Gate"));

var _makeStyles = _interopRequireDefault(require("../styles/makeStyles"));

var _core = require("@material-ui/core");

var _excluded = ["condition", "children"];

var styles = function styles() {
  return {
    loadingContainer: {
      zIndex: '100',
      background: 'rgba(249, 249, 249, 0.8)',
      position: 'absolute',
      top: 0,
      bottom: 0,
      right: 0,
      left: 0,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    }
  };
};

exports.styles = styles;
var useStyles = (0, _makeStyles["default"])(styles);

var LoadingGate = function LoadingGate(_ref) {
  var condition = _ref.condition,
      children = _ref.children,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var classes = useStyles();

  var ref = /*#__PURE__*/_react["default"].createRef();

  return /*#__PURE__*/_react["default"].createElement(_Gate["default"], {
    condition: condition,
    alternate: /*#__PURE__*/_react["default"].createElement("div", {
      className: classes.loadingContainer
    }, /*#__PURE__*/_react["default"].createElement(_core.Fade, {
      "in": !condition,
      unmountOnExit: true
    }, /*#__PURE__*/_react["default"].createElement("div", {
      ref: ref
    }, /*#__PURE__*/_react["default"].createElement(_core.CircularProgress, null))))
  }, /*#__PURE__*/_react["default"].createElement(_core.Fade, {
    "in": condition,
    unmountOnExit: true
  }, /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({
    ref: ref
  }, props), children)));
};

LoadingGate.propTypes = {
  condition: _propTypes["default"].bool.isRequired,
  children: _propTypes["default"].node.isRequired
};
var _default = LoadingGate;
exports["default"] = _default;